export default __webpack_public_path__ + "static/media/bdswissReal04_downloadMT4.d15dfb9c.png";